export function getLocale(state) {
  return state.intl.locale;
}



// WEBPACK FOOTER //
// src/selectors/intl.js